import { SalesByValueReportItem } from '../../../types/salesByValueReportItem'
import { SalesReportFormattedGraphData } from '../types/salesReportFormattedGraphData'
import { getEmptyGraphValues } from './getEmptyGraphValues'

export const getFormattedGraphTemplateValues = (
  salesReport: SalesByValueReportItem[],
  maximumReportsCount: number,
): SalesReportFormattedGraphData[] => {
  const sortedReports = salesReport.sort(
    (salesReportA, salesReportB) =>
      (salesReportB?.summary?.all.netTotal ?? 0) - (salesReportA?.summary.all.netTotal ?? 0),
  )

  // Build graph template items with unique IDs and empty values
  const formattedSalesReport: SalesReportFormattedGraphData[] = sortedReports.reduce<SalesReportFormattedGraphData[]>(
    (graphItems, salesReportItem) => {
      const reportItemId = 'customerId' in salesReportItem ? salesReportItem.customerId : salesReportItem.productId

      const reportItemTitle =
        'customerName' in salesReportItem ? salesReportItem.customerName : (salesReportItem.productName ?? '-')

      return [
        ...graphItems,
        {
          id: reportItemId,
          key: graphItems.length,
          values: getEmptyGraphValues(),
          display: {
            title: reportItemTitle,
            tooltip: reportItemTitle,
          },
        },
      ]
    },
    [],
  )

  // Add empty reports to display in graph if there is less then maximumReportsCount
  if (formattedSalesReport.length < maximumReportsCount) {
    const missingCount = maximumReportsCount - formattedSalesReport.length

    const emptyItems = Array.from({ length: missingCount }, (_, index) => ({
      id: index,
      key: formattedSalesReport.length + index,
      values: getEmptyGraphValues(),
      display: { title: '-', tooltip: '-' },
    }))

    formattedSalesReport.push(...emptyItems)
  }

  return formattedSalesReport
}
